import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  letDownTitle: { id: "funding-application: let down title - updated", defaultMessage: "We can't fund you yet" },
  letDownSubHeading: {
    id: "funding-application: let down subheading",
    defaultMessage:
      "We're currently unable to fund businesses with average revenue per month below {minRevenueAmount}.",
  },
  letDownLinkToEligibilityCriteriaMsg: {
    id: "funding-application: let down link to eligibility criteria message",
    defaultMessage: "Read our {link} for more details.",
  },
  letDownLinkToEligibilityCriteriaAnchor: {
    id: "funding-application: let down link to eligibility criteria anchor",
    defaultMessage: "Eligibility criteria",
  },
  letDownReasonGeography: {
    id: "funding-application: let down reason geography",
    description: "Message when customer is not eligible because of where they are based",
    defaultMessage:
      "<p>One of our key eligibility requirements is that businesses must be incorporated in the United States, Canada, United Kingdom, Australia, Ireland, Spain, the Netherlands, Belgium, Denmark, Germany, or Sweden.</p><p>Unfortunately, as your business is currently not incorporated in one of these countries, we are unable to approve your application at this time.</p>",
  },
  letDownReasonBusinessModelGeo: {
    id: "funding-application: let down reason business model geo",
    description:
      "Message when customer with non-ecommerce business model is not eligible because they are in an unsupported geography",
    defaultMessage:
      "Currently, we can only provide funding for companies who sell physical products online in your region. If you have a Shopify, Amazon, BigCommerce, WooCommerce, Stripe, Google Analytics or Magento account, please press back to continue your application.",
  },
  letDownReasonBusinessModelGeoMultiSelect: {
    id: "funding-application: let down reason business model geo multi select",
    description:
      "Message when customer with non-ecommerce business model is not eligible because they are in an unsupported geography",
    defaultMessage:
      "Currently, we can only offer financing for online businesses selling physical products to end consumers (B2C) in your region.",
  },
});
